import {useEffect, useState} from 'react';
import type {FloatingContext} from '@floating-ui/react';
import {FLOATING_EVENT_VISIBILITY_HIDE} from '../constants';

/**
 * It pauses the returnFocus behavior temporarily to prevent focus issues during scroll.
 */
export function useReturnFocusState(context: FloatingContext, externalValue?: boolean) {
    const [returnFocus, setReturnFocus] = useState(externalValue ?? true);
    useEffect(() => {
        setReturnFocus(externalValue ?? true);
    }, [externalValue]);

    useEffect(() => {
        let timeout: ReturnType<typeof setTimeout>;
        function pauseFocusReturn() {
            setReturnFocus(prevState => {
                if (prevState) {
                    clearTimeout(timeout);
                    timeout = setTimeout(() => {
                        setReturnFocus(prevState);
                    }, 10);
                    return false;
                }
                return prevState;
            });
        }
        context.events.on(FLOATING_EVENT_VISIBILITY_HIDE, pauseFocusReturn);

        return () => {
            clearTimeout(timeout);
            context.events.off(FLOATING_EVENT_VISIBILITY_HIDE, pauseFocusReturn);
        };

    }, [context.events]);

    return returnFocus;
}
